import axios from "axios";

const PUBLIC_ENDPOINTS = [
  "/dashboard/auth/login",
  "/auth/forgot-password-mobile",
  "/dashboard/auth/refresh-token",
];

// default
axios.defaults.baseURL = "https://api.we-reload.com/api";

// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// intercepting to capture errors
axios.interceptors.request.use(
  (config: any) => {
    const isPublicEndpoint = PUBLIC_ENDPOINTS.some(endpoint => 
      config.url.includes(endpoint)
    );
    // Skip auth header for login/register endpoints
    if (!isPublicEndpoint) {
      const user = getLoggedinUser();
      
      if (user?.jwt) {
        config.headers.Authorization = `Bearer ${user.jwt}`;
      }
    }
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response: any) {
    return response.data ? response.data : response;
  },
  function (error: any) {
    // Handle Strapi v4 error response format
    const errorResponse = error.response?.data;
    let message: any;
    
    // Check if it's a 401 unauthorized error
    if (error.response?.status === 401) {
      window.location.href = "/logout";
      message = "Session expired. Please login again.";
    } else {
      // Handle other error cases
      switch (error.response?.status) {
        case 500:
          message = "Internal Server Error";
          break;
        case 404:
          message = "Sorry! the data you are looking for could not be found";
          break;
        default:
          message = errorResponse?.error?.message || error.message || error;
      }
    }
    return Promise.reject(message);
  }
);

class APIClient {
  /**
   * Fetches data from given url
   */
  get = (url: any, params: any) => {
    let response: any;

    let paramKeys: any = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url: any, data: any) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: any, data: any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url: any, config: any) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, getLoggedinUser };